import "./servicios.scss";
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrosshairs } from '@fortawesome/free-solid-svg-icons';


const serviciosData = [
  { nombre: 'Estados Parcelarios', descripcion: '• Documento técnico-legal que certifica la situación física y jurídica de un inmueble.\n• Es obligatorio en cambios de derechos reales del inmueble como compra-ventas, sucesiones, donaciones, hipotecas.' },
  { nombre: 'Mensuras', descripcion: '• Procedimiento mediante el cual se determinan los limites y dimensiones de un terreno.\n• Tiene como resultado un plano aprobado por Catastro, que deja registrado el inmueble en forma oficial y legal.\n• Tipos de planos de mensura: Subdivisión, unificación, usucapión, anexión, Ley Pierri.' },
  { nombre: 'Subdivisiones', descripcion: '• Permite subdividir un inmueble en parcelas más pequeñas.\n• Se utiliza cuando se quiere vender por partes como también en desarrollos inmobiliarios.' },
  { nombre: 'Propiedad Horizontal', descripcion: '• Forma legal de subdividir un inmueble en unidades funcionales (como casas o departamentos) y sectores comunes.\n• El plano de PH es necesario para que se tenga la escritura de cada departamento, dúplex o PH tipo casa, locales comerciales, oficinas, barrios cerrados, countries o clubes de campo.' },
  { nombre: 'Loteos', descripcion: '• Procedimiento de división de un terreno en lotes para urbanización o desarrollo.\n• Se utiliza en proyectos urbanísticos o desarrollos inmobiliarios donde se crean nuevos barrios o sectores.' },
  { nombre: 'Amojonamientos', descripcion: '• Proceso mediante el cual se colocan mojones en el terreno para señalar sus límites, de acuerdo con un relevamiento topográfico realizado previamente.\n• Se realiza al haber dudas o conflictos sobre límites con vecinos, en procesos de subdivisión y unificación de terrenos, y también antes de construir o ampliar edificaciones cercanas a los bordes del inmueble.' },
  { nombre: 'Replanteo de Ejes de Obra', descripcion: '• Marcación en el terreno de las líneas o puntos que definen la ubicación exacta de una construcción.\n• Se realiza antes de iniciar la construcción, para asegurar que la obra se realice conforme al proyecto aprobado.' },
  { nombre: 'Relevamiento Topograficos', descripcion: '• Levantamiento detallado de la superficie y características físicas del terreno, incluyendo altimetría y detalles naturales o construidos.\n• Se realiza para estudios previos a proyectos de obra, diseño urbanístico, o diagnóstico del terreno.' },
  { nombre: 'Nivelaciones', descripcion: '• Medición y determinación de las diferencias de altura o nivel entre distintos puntos del terreno.\n • Se realiza para diseño de obras civiles, cálculo de movimientos de tierra y obras hidráulicas.' },
  { nombre: 'Georreferenciaciones', descripcion: '• Proceso técnico que asigna coordenadas geográficas precisas a un punto, inmueble y o superficie relevada; vinculándolo al Marco de Referencia Oficial (Posgar2007).\n• Se realiza para planos de mensura, ordenamiento territorial, relevamientos y obras de ingeniería.' },
];

export default function Servicios() {
  const [servSelec, setServSelec] = useState(serviciosData[0]);

  return (
    <div className="servicios" id="servicios">
      <h1 className="titulo">SERVICIOS</h1>

      <div className="listas">
        <ul>
          {serviciosData.map((servicio, index) => (
            <li key={index} onClick={() => setServSelec(servicio)}>
              <FontAwesomeIcon icon={faCrosshairs} className="icon" />
              <span>{servicio.nombre}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="descripcion">
        <h5>{servSelec.nombre}</h5>
        <p>
          {servSelec.descripcion.split("\n").map((linea, i) => (
            <React.Fragment key={i}>
              {linea}
              <br />
            </React.Fragment>
          ))}
        </p>
      </div>
    </div>
  );
}
